export default __webpack_public_path__ + "static/media/Icon=Tasks.57cfad78.svg";